import type { ReactNode } from 'react'

import { BaseList } from '../base-list'
import type { ListVariant } from '../list.context'

type Props = {
  variant?: ListVariant
  children: ReactNode
  className?: string
}

export const BulletedList = ({
  variant = 'medium',
  children,
  className,
}: Props) => (
  <BaseList
    className={className}
    component="ul"
    data-testid="bulleted-list"
    variant={variant}
  >
    {children}
  </BaseList>
)
